import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';
import {
  DOM_LENTA_RU_DOMAIN,
  JAMONLINE_DOMAIN,
  LENTA_COM_DOMAIN,
  MONETKA_DOMAIN,
  REMI_DOMAIN,
  UTKONOS_DOMAIN,
} from '@lentau/ui-kit/core/constants/domains';

export const QUERY_HOST_BY_BRAND: ReadonlyMap<RetailBrands, string> = new Map<RetailBrands, string>([
  [RetailBrands.LENTA_ONLINE, LENTA_COM_DOMAIN],
  [RetailBrands.UTKONOS, UTKONOS_DOMAIN],
  [RetailBrands.MONETKA, MONETKA_DOMAIN],
  [RetailBrands.DOM, DOM_LENTA_RU_DOMAIN],
  [RetailBrands.SUPERJAM, JAMONLINE_DOMAIN],
  [RetailBrands.REMI, REMI_DOMAIN],
]);

export const getQueryHost: (brand: RetailBrands) => string = (brand: RetailBrands): string =>
  QUERY_HOST_BY_BRAND.get(brand) ?? LENTA_COM_DOMAIN;
